import { render, staticRenderFns } from "./schedulingAppointment.vue?vue&type=template&id=b23228aa"
import script from "./schedulingAppointment.js?vue&type=script&lang=js&external"
export * from "./schedulingAppointment.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports